// extracted by mini-css-extract-plugin
export default {"intro":"intro_intro__cVhPd","introContent":"intro_introContent__9txoj","btnGetStarted":"intro_btnGetStarted__JdSQr"};